import { Controller } from 'stimulus'
import { InputMasking } from 'classes/input-masking'
import moment from 'moment'

/**
 * Manages js for the borrower-income step of purchase and refinance DM
 *
 * @class BorrowerIncomeController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [
    'employmentForm',
    'employmentTemplate',
    'longFormContainer',
    'shortFormContainer',
    'nextVisible',
    'selfEmployedForm',
    'selfEmployedTemplate'
  ]

  /**
   * @function controllers.BorrowerIncomeController.initialize
   * @memberof controllers
   * @description add event listeners for spawn and nextVisible
   *
   * @return {undefined} manipulates the dom.
   *
   */
  initialize() {
    this.longFormContainerTargets.forEach(formsContainer => {
      formsContainer.addEventListener('nextVisible', this._toggleNextVisible.bind(this))
      formsContainer.addEventListener('spawnNew', this._maybeSpawnNewForm.bind(this))
    })

    this.shortFormContainerTargets.forEach(formsContainer => {
      formsContainer.addEventListener('nextVisible', this._toggleNextVisible.bind(this))
    })
  }

  /**
  * @function Controllers.BorrowerIncomeController._toggleNextVisible
  * @memberof Controllers
  * @description Dispatch a custom event to toggle nextVisible
  * @param {event} event
  * @private
  *
  * @return {undefined}
  *
  */
  _toggleNextVisible(event) {
    this.nextVisibleTarget.value = event.detail.toggle
    this.nextVisibleTarget.dispatchEvent(new Event('change'))
  }


  /**
  * @function Controllers.BorrowerIncomeController._maybeSpawnNewForm
  * @memberof Controllers
  * @description If the start date of the event is within the last two years,
  * call the _addIncomeFields function
  * @param {event} event
  * @private
  *
  * @params {event} event from EventListener
  *
  * @return {undefined}
  *
  */
  _maybeSpawnNewForm(event) {
    const startDate = moment(event.detail.start_on, 'MM/YYYY')
    const twoYearsAgo = moment().subtract(2, 'years')
    twoYearsAgo.isBefore(startDate) ? this._addIncomeFields(event.detail.type) : null
  }

  /**
  * @function Controllers.BorrowerIncomeController._addIncomeFields
  * @memberof Controllers
  * @description Copy the template from the corresponding haml file and add to the DOM
  * @param {type} type of employment, either employment or self-employment
  * @private
  *
  * @params {String}
  *
  * @return {undefined}
  *
  */
  _addIncomeFields(type) {
    let template
    let parent
    if (type === 'employment') {
      template = this.employmentTemplateTarget.content.cloneNode(true)
      parent = this.employmentFormTarget
    } else {
      template = this.selfEmployedTemplateTarget.content.cloneNode(true)
      parent = this.selfEmployedFormTarget
    }

    parent.appendChild(template)
    InputMasking.applyAll()
  }
}
